import { render, staticRenderFns } from "./LoginBySubDomain.vue?vue&type=template&id=55e1db80&scoped=true&"
import script from "./LoginBySubDomain.vue?vue&type=script&lang=js&"
export * from "./LoginBySubDomain.vue?vue&type=script&lang=js&"
import style0 from "./LoginBySubDomain.vue?vue&type=style&index=0&id=55e1db80&scoped=true&lang=scss&"
import style1 from "./LoginBySubDomain.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e1db80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VForm,VIcon,VImg,VTextField})
